import ws from '@api/webservice'
import config from '@app/config'

const api = {
  all: (siteId: string, manifestationId: string) =>
    ws<CommandeListResponse>(config.ws.commande.all + `?siteId=${siteId}&manifestationId=${manifestationId}`, 'GET'),
  expo: (siteId: string, manifestationId: string) =>
    ws<CommandeNonConnecteListResponse>(
      config.ws.commande.expo + `?siteId=${siteId}&manifestationId=${manifestationId}`,
      'GET'
    ),
}

export default api
